import React, {useMemo} from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";

import {cartItemInterface} from "./cartItemInterface";
import {getWizardGroupFromCurrentSteps} from "../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";


const ShoppingCartItemsListItemEditButton = (props) => {

  const {cartItem, handleEditClick, isMobile, wizardList, allWizardsValues, isWizardEditable} = props;

  // isWizardEditable is resolved once for the whole cart in shoppingCartItemsList (buildWizardEditableMap),
  // so the wizard graph is not walked again for every single cart item. The local calculation below is
  // only the fallback for the places that render this button without the shared map.
  const hasSharedResult = typeof isWizardEditable === "boolean";

  const locallyEditable = useMemo(() => {
    if (hasSharedResult) {
      return true
    }
    if (cartItem.fromWizardGroupId && allWizardsValues) {
      const neededObject = allWizardsValues.find(wizValueObject => (wizValueObject.quoteIndex === cartItem.currentQuote)
        && (wizValueObject.wizardItemId === cartItem.fromWizardId));
      const selectedWizValues = neededObject && neededObject.wizardSelectedValues ? neededObject.wizardSelectedValues : null;
      const wizardItem = wizardList.find(wizItem => wizItem.id === cartItem.fromWizardId);
      const {neededStep} = getWizardGroupFromCurrentSteps(wizardItem, selectedWizValues, cartItem.fromWizardGroupId);
      if (!neededStep) {
        return false
      }
    }
    return true
  }, [hasSharedResult, allWizardsValues, wizardList, cartItem])

  const isEditable = hasSharedResult ? isWizardEditable : locallyEditable;

  if (!isEditable) {
    return null
  }

  if (isMobile) {
    return (
      <button className="ui-smallbutton ui-smallbutton--edit" onClick={handleEditClick}/>
    )
  }

  return (
    <span className="link link--blue" onClick={handleEditClick}>
      <FormattedMessage id="shoppingCart.featureInCartEditLink"/>
    </span>
  )
}

ShoppingCartItemsListItemEditButton.propTypes = {
  handleEditClick: PropTypes.func.isRequired,
  cartItem: PropTypes.shape(cartItemInterface).isRequired,
  isWizardEditable: PropTypes.bool,
}

const mapStateToProps = (store, ownProps) => {
  const {isMobile} = store.serverState;

  // when the shared result is provided we do not subscribe to the wizard state at all,
  // which also removes one store subscription per cart item
  if (typeof ownProps.isWizardEditable === "boolean") {
    return {isMobile}
  }

  const {allWizardsValues, wizardList} = store.wizardState;

  return {
    wizardList,
    allWizardsValues,
    isMobile,
  };
};

export default connect(mapStateToProps)(ShoppingCartItemsListItemEditButton)
